module.exports = __webpack_public_path__ + "img/volcano.3989eee5.png";